export const VISA_TYPE_MAP = {
  immigrant: 'immigrant',
  'non-immigrant': 'non-immigrant',
} as const

export const CASE_ARCHIVE_STATUS_MAP = {
  ALL: 'all',
  ARCHIVED: 'archived',
  ACTIVE: 'active',
} as const
